import React from "react";
import { Card } from '@curves/ui-base';

import { CyclePurchaseDetailHistoryCard } from "@Local/CyclePurchase/Detail/History";
const CyclePurchaseDetailHistory = props => {
	const { memberID, cycleOrderID } = props;
	return (
		<Card className="p-4">
			<Card.CardContent>
				<CyclePurchaseDetailHistoryCard memberID={memberID} cycleOrderID={cycleOrderID} />
			</Card.CardContent>
		</Card>
	);
};
export default CyclePurchaseDetailHistory;
